import * as z from "zod/v4";

const TrackingSampleSchema_ = z.object({
  trackingCode: z.string(),
  orderId: z.string(),
  teamId: z.string(),
  teamName: z.string().nullish(),
});

export const TrackingSampleSchema: z.ZodType<TrackingSample> =
  TrackingSampleSchema_;

export interface TrackingSample extends z.infer<typeof TrackingSampleSchema_> {}

export const GetSampleTrackingCodesInputSchema = z.object({
  carrier: z.string(),
  teamId: z.string().optional(),
  limit: z.number().default(3),
});

export const GetSampleTrackingCodesOutputSchema = z.object({
  samples: z.array(TrackingSampleSchema),
});

export type GetSampleTrackingCodesInput = z.infer<
  typeof GetSampleTrackingCodesInputSchema
>;
export type GetSampleTrackingCodesOutput = z.infer<
  typeof GetSampleTrackingCodesOutputSchema
>;

export const getSampleTrackingCodes = {
  name: "getSampleTrackingCodes" as const,
  input: GetSampleTrackingCodesInputSchema,
  output: GetSampleTrackingCodesOutputSchema,
};
